var toString = {}.toString;
var isType = function (value, type) { return toString.call(value) === '[object ' + type + ']'; };
export default isType;
//# sourceMappingURL=is-type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-type.js
// module id = 24
// module chunks = 3